module.exports = __webpack_public_path__ + "96e09745f762c554823a20b25beb0c2f.jpg";